import { useTheme } from "@hooks/useTheme";

const ColorBox = ({ colorName, size = 'md', showLabel = true, className = '', t = null }) => {
  const { colors } = useTheme();

  const getColorClass = (colorName) => {
    const colorMap = {
      'black': 'bg-[#000000] text-white',
      'red': 'bg-[#CC1010] text-white',
      'orange': 'bg-[#FF8300] text-white',
      'blue': 'bg-[#355DFF] text-white',
      'steelblue': 'bg-[#355DFF] text-white',
      'green': 'bg-[#1C991A] text-white'
    };
    return colorMap[colorName] || 'bg-gray-500 text-white';
  };

  const getSizeClasses = (size) => {
    switch (size) {
      case 'sm':
        return 'w-4 h-4';
      case 'md':
        return 'w-6 h-6';
      case 'lg':
        return 'w-8 h-8';
      case 'xl':
        return 'w-12 h-12';
      default:
        return 'w-6 h-6';
    }
  };

  // Helper function to translate color name
  const translateColorName = (color) => {
    if (!t) return color;
    const colorMap = {
      'black': t('license-policy.colors.black'),
      'red': t('license-policy.colors.red'),
      'orange': t('license-policy.colors.orange'),
      'steelblue': t('license-policy.colors.steelblue'),
      'green': t('license-policy.colors.green'),
    };
    return colorMap[color] || color;
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`${getSizeClasses(size)} rounded ${getColorClass(colorName)}`}></div>
      {showLabel && (
        <span className={`text-sm ${colors.textStaticWhite} capitalize`}>{translateColorName(colorName)}</span>
      )}
    </div>
  );
};

export default ColorBox; 